module.exports = __webpack_public_path__ + "img/bc0461bdc43a04c9f16635da55499b4b.png";